import moment from 'moment';
import _ from 'underscore';
import parseError from '../../parseError';
import { Toast } from '../../../../../../Components/Notification';

const deleteMeal = async ({ state, userId, removeMeal, updateState, refreshPage }) => {
  const { resource, itemDetails } = state;
  const { mealStartTime, mealId } = itemDetails;
  const date = moment(mealStartTime).format('M/D/YYYY (ddd)');
  let notification = {type: 'success', message: 'Meal Deleted', description: `For ${resource.name} on ${date}`};
  const parameters = {
    mealId,
    updatingUserId: userId
  };

  try {
    await removeMeal(parameters);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'removeMeal',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Deleting Meal Failed",
        description: `For [${resource.name} on ${date}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  refreshPage
}

export default deleteMeal;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/CRUD/meal/deleteMeal.js